import React from 'react';
import { Link} from 'react-router-dom';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWallPte';
import Testimonial from '../components/Frontend/VideoPTETestimonial';
import Packages from '../components/Frontend/Packages';
import WhyLove from '../components/Frontend/WhyLove';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
class Pte extends React.Component {
    componentDidMount() {
        // ReactGA.initialize('UA-157984080-1');
        // ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('3847665161963731');
        ReactPixel.pageView();
    }
 render(){
    return (
    <React.Fragment>
    <Helmet htmlAttributes>
        <title>Top PTE Coaching Classes in Gurdaspur | LA Academy India</title>
        <meta name="twitter:title" content="Best PTE Centre In Gurdaspur - LA-Language Academy" />
    	<meta property="og:title" content="Best PTE Centre In Gurdaspur - LA-Language Academy" />

    	<meta name="description" content="Join LA Language Academy's PTE coaching classes in Gurdaspur. Achieve your best scores with expert instruction and tailored practice materials." />
        <meta name="twitter:description" content="Best PTE institute in Gurdaspur LA-Language Academy, offers three packages (Bronze, Silver, and Gold), including study materials, free PTE practice exams set with scorecards and a nail exam like a pro." />
        <meta property="og:description" content="Best PTE institute in Gurdaspur LA-Language Academy, offers three packages (Bronze, Silver, and Gold), including study materials, free PTE practice exams set with scorecards and a nail exam like a pro." />
    </Helmet>
    <Header />
    <div class="innerPage">
        <section class="bannerOuter">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h1>Learn from the<br />Best PTE Coaching in Gurdaspur</h1>
                        {/*<span>Join the top PTE Training Institute and hone your English skills under the guidance of PTE Experts</span><br />*/}

                        <ul className="impo-list">
                            <li className="mb-1">ISO Certified Institute</li>
                            <li className="mb-1">Well-equipped Labs</li>
                            <li className="mb-1">Full-Length Mock Tests</li>
                        </ul>
                        <br />
                        <br />
                        <Link to="/auth/register" class="themeBtn">Register Now</Link>
                        <br/>
                        <a href="javascript:;" class="downArrow"><img src="images/banner-arrow.png" alt="banner-arrow" /></a>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <section className="pteInfo">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>LA-Language Academy - PTE Coaching Institute In Gurdaspur</h2>
                    {/*<p>PTE - A ( Pearson Test of English Academic) is a highly popular exam among the people from all corners of the globe, who want to accomplish their dream of studying abroad or become a permanent resident of an English speaking country like Australia. This well-designed computer-based test assesses the candidate's English language proficiency on his/her Speaking, Writing, Reading, and Listening skills.</p>

                    <p>To smash the PTE exam with an excellent score, a person has to perform well in all of these four sections, as being weak in any of these might ruin your overall exam performance and final result.</p>*/}

                    <p className="heading">Moving Abroad - A Dream for Many</p>
                    <p>
                        When an Indian citizen moves abroad, and that too to a country like Australia, the one who is in India also wants to experience the same, i.e. experiencing a different culture, knowing the people and many more. But, the Indian citizen needs to crack a test like PTE exam and score well to qualify.
                    </p>
                    <p>
                        Don't worry! LA-Language Academy - Gurdaspur PTE exam institute, one of the best PTE exam institutes, professionally helps the Indian citizens in Gurdaspur, India and everywhere around to crack the PTE exam with the guidance of expert tutors to study in Australia.
                    </p>

                    <p className="heading">But What is PTE?</p>
                    <p>PTE (Pearson Test for English Academic) is an online English language proficiency test to apply for permanent residence in Australia. The institute provides an effective PTE exam course pattern for the Indian citizen candidates in Gurdaspur to improve their English proficiency skills.</p>
                    <p>The team of expert tutors create a syllabus for the candidates willing to appear in the PTE exam according to the exam pattern for PTE. The syllabus of the PTE institute in Gurdaspur includes practicing a lot for the test, mock tests, assessments, and regular feedback. Candidates preparing for the exam positively review the feedback and believe in improving their scores frequently.</p>
                    <p>The tutors of the LA-Language Academy at Gurdaspur PTE test centre are fully dedicated to the candidate's success. They help the candidate to achieve excellent results in the PTE exams.</p>
                    <p>The PTE online portal of the LA-Language Academy PTE coaching classes Gurdaspur gives the candidate an idea of the exam pattern, the type of questions asked, mock tests and online study resources from the right sources. The experts of the PTE coaching centre in Gurdaspur train candidates to access the portal efficiently by increasing their confidence level to appear in the PTE exam.</p>

                    <p>Is clearing the test seems like a daunting task to you because of your weak areas in English? Are you confused about how to create a proper roadmap for your PTE preparation? Don't worry! under the guidance of experts from the top PTE training institute, you can prepare well for the exam and pave your way to success.</p>

                    <p>Language Academy, the institute known for providing the best PTE coaching classes in Gurdaspur, strongly focuses on the students’ strengths and weaknesses to define the right strategy for each of them. Noting their weak areas, we help them to improve these with our expert tips, latest study & practice material, and mock tests. The exam is not a hard nut to crack if you follow all the points taught during the PTE classes. With your sincere efforts and our direction, you can easily ace the exam.</p>

                    <p>Do you want to join the top PTE Institute in Gurdaspur, India? Call us on <a style={{color:"#51cbce"}} href="tel:7652811911">+91 7652811911</a> for all your queries and doubts. We provide both online coaching and in-class PTE training in Gurdaspur, India for the students who are planning to pursue their higher studies. For booking the free demo PTE classes in Gurdaspur, you can drop us a mail at <a style={{color:"#51cbce"}} href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> We would love to assist! So, are you ready to start your journey to success with the best PTE coaching centre?</p>

                    <div className="pteCntnt text-center">
                        <div className="row cardsOuter">

                            <div className="col-sm-4">
                                <img src="images/online-coching.png" alt="online-coching" />
                                <h3>Online PTE Coaching Classes</h3>
                                <p>Get the best online PTE trainer for your exam preparation.</p>
                            </div>


                            <div className="col-sm-4">
                                <img src="images/book.png" alt="book" />
                                <h3>Study Material</h3>
                                <p>We have infinite resources & study material for PTE exam preparation.</p>
                            </div>

                        </div>
                    </div>



                </div>
            </div>
        </div>
    </section>
    <section className="pteExam">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>PTE Exam</h2>

                    <p>The PTE exam has four sections: Reading, Writing, Speaking and Listening. Candidates will learn how to read fluently in the country's native English Language, frame short answers, complete a sentence, solve MCQs and fill-ups, and maintain listening speed, then mark the correct answer in MCQs while listening.</p>
                    <p>Other than this, candidates will get the access to the online class and other study material, which includes:</p>

                    <p className="heading">Access to Online PTE Portal</p>
                    <p>Candidates will access the online PTE portal to get a real idea of how the PTE exams are conducted.</p>

                    <p className="heading">Access to Mock Tests with Scorecard</p>
                    <p>Candidates will get access to full-length mock tests. They will also get their scorecard for analysis.</p>

                    <p className="heading">Access to Online Classes</p>
                    <p>Candidates will access all online classes, including one strategy-building class and live practice sessions.</p>
                </div>
            </div>
        </div>
    </section>
    <section className="pteInfo">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>Why choose LA-Language Academy PTE coaching institute in Gurdaspur</h2>

                    <p><h3 className="heading">Positive Results</h3></p>
                    <p>LA-Language Academy PTE centre in Gurdaspur follows an approach to developing the English proficiency skills that will lead to positive results for the candidates appearing in the PTE exam.</p>

                    <p><h3 className="heading">Personal Attention</h3></p>
                    <p>Every candidate preparing for the PTE exams at the LA-Language Academy PTE classes in Gurdaspur gets personal attention from a team of experts.</p>

                    <p><h3 className="heading">Free Trial Classes</h3></p>
                    <p>Candidates of LA-Language Academy PTE institute in Gurdaspur get access to free trial face-to-face classes. The free trial classes approach benefits the candidate to evaluate themselves before preparing for PTE exams.</p>

                    <p><h3 className="heading">Team of Experts</h3></p>
                    <p>LA-Language Academy PTE coaching in Gurdaspur has an expert team of tutors who offers their proper guidance to the candidates. The team of experts at the LA-Language Academy Gurdaspur PTE centre also provides regular feedback to the candidate for improvements.</p>

                    <p><h3 className="heading">Mock Tests with the Same PTE Exam Pattern</h3></p>
                    <p>LA-Language Academy Gurdaspur PTE test centre provides access to free mock tests to the candidates, and this method gives an idea to the candidates of how the pattern of the PTE exam will be.</p>
                </div>
            </div>
        </div>
    </section>
    <section className="packages widePackages">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>LA-Language Academy Pearson Test Centre Gurdaspur offers three packages:</h2>
                    <p>The three packages include study materials, free PTE mock tests with scorecards and proper feedback for candidates of the PTE centre in Gurdaspur. The premium package (Gold) includes unlimited classes with mock class tests for candidates to prepare for the PTE exam in Gurdaspur.</p>
                    <div className="featurePlans">
                       <div className="featurePackage">
                          <h3>Bronze</h3>
                          <ul>
                             <li>Validity 10 Sessions</li>
                             <li>Method of Delivery Online</li>
                             <li>Access to all our proven methods & strategies</li>
                             <li>1-1 Personalised Feedback</li>
                             <li>Access to Online Resources</li>
                             <li>Online Mock Tests</li>
                          </ul>
                       </div>
                       <div className="featurePackage">
                          <h3>Silver</h3>
                          <ul>
                             <li>Validity 4-week</li>
                             <li>Method of Delivery Face-2-Face</li>
                             <li>Access to all our proven methods & strategies</li>
                             <li>1-1 Personalised Feedback</li>
                             <li>Access to Online Resources</li>
                             <li>Online Mock Tests</li>
                             <li>Class Mock Tests</li>
                             <li>Access to Practice Lab</li>
                          </ul>
                       </div>
                       <div className="featurePackage green">
                          <h3>Gold</h3>
                          <ul>
                             <li>Validity Unlimited (*Valid for 1 Year)</li>
                             <li>Method of Delivery Face-2-Face</li>
                             <li>Access to all our proven methods & strategies</li>
                             <li>1-1 Personalised Feedback</li>
                             <li>Access to Online Resources</li>
                             <li>Unlimited Classes</li>
                             <li>Online Mock Tests</li>
                             <li>Class Mock Tests</li>
                             <li>Access to Practice Lab</li>
                          </ul>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
	<Testimonial title="PTE Success Stories" />
	<WhyLove />
	<FameWall location="Gurdaspur" />
    <section className="success-numbers pteExam">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>Success Number</h2>

                    <p>An institute is successful when a candidate cracks the exam with flying colors, which is the LA-Language Academy's goal. The institute aims to provide good quality support to candidates appearing for the PTE exams. <span className="highlight"><strong>97% of the candidates scored 90 plus</strong></span> in the PTE exams with LA-Language Academy’s assistance.</p>
                </div>
            </div>
        </div>
    </section>

    <section className="faq-section">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <h2>FAQ</h2>
                </div>
                <div className="col-sm-12">
                    <div className="accordion" id="faqExample">
                        <div className="customCard">
                            <div className="custom-card-header" id="headingOne">
                                <h5 className="mb-0">
                                    <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                      Q. How can I book a free online PTE demo class?
                                    </button>
                                </h5>
                            </div>
                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#faqExample">
                                <div className="card-body px-0 py-3">
                                    <b>Answer:</b> You can visit our website on the courses page and can book a free online PTE demo class.
                                </div>
                            </div>
                        </div>
                        <div className="customCard">
                            <div className="custom-card-header" id="headingTwo">
                                <h5 className="mb-0">
                                <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                  Q. Will I get a confirmation mail after a booking for the online class?
                                </button>
                              </h5>
                            </div>
                            <div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" data-parent="#faqExample">
                                <div className="card-body px-0 py-3">
                                    <b>Answer:</b> Yes, you will receive a confirmation mail after a booking for the online class.
                                </div>
                            </div>
                        </div>
                        <div className="customCard">
                            <div className="custom-card-header" id="headingThree">
                                <h5 className="mb-0">
                                    <button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                      Q. What are the countries that accept PTE?
                                    </button>
                                  </h5>
                            </div>
                            <div id="collapseThree" className="collapse show" aria-labelledby="headingThree" data-parent="#faqExample">
                                <div className="card-body px-0 py-3">
                                    <b>Answer:</b> Canada, Australia, New Zealand, Ireland and the UK are the countries that accept PTE.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
	<Footer />
    </React.Fragment>);
    }
}

export default Pte;
